<template>
  <div
    id="step-title"
    class="title-container"
  >
    <div>
      <i
        v-if="icon"
        class="fas fa-lg"
        :class="icon"
      />
      <h4 class="title is-4 is-inline">
        {{ title }}
      </h4>
    </div>
    <p class="subtitle is-size-6-mobile">
      {{ subtitle }}
      <span
        v-if="helpText"
        class="help-text is-block has-text-grey is-size-6 has-text-weight-bold"
      >{{ helpText }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'StepTitle',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    icon: {
      type: String,
      required: false,
      default: ''
    },
    helpText: {
      type: String,
      required: false,
      default: ''
    }
  }
};
</script>

<style scoped lang="scss">
.title-icon {
  width: 40px;
  margin-right: 0.5rem;
  margin-top: -3.5rem;
}

.section-title {
  vertical-align: middle;
}

.title-container {
  margin-bottom: 3rem;
}

i {
  margin-right: 0.5rem;
  vertical-align: baseline;
}

.help-text {
  margin-top: 0.4rem;
}
</style>
